// ============================================
// ⏳ 로딩 스피너 컴포넌트
// ============================================
import React from 'react';

// 전체 화면 로딩
export function LoadingSpinner({ message = '로딩 중...' }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <img
          src="/logo192.png"
          alt="Loading"
          style={styles.logoSpinner}
        />
        <div style={styles.message}>{message}</div>
      </div>
    </div>
  );
}

// 인라인 로딩 (작은 버전)
export function InlineSpinner({ size = 'medium', color = '#424242' }) {
  const sizeMap = {
    small: 20,
    medium: 40,
    large: 60
  };
  
  const spinnerSize = sizeMap[size] || sizeMap.medium;
  
  return (
    <div style={{...styles.inlineSpinner, width: spinnerSize, height: spinnerSize}}>
      <div style={{
        ...styles.spinner,
        width: spinnerSize,
        height: spinnerSize,
        borderWidth: Math.max(2, spinnerSize / 10),
        borderColor: `${color}30`,
        borderTopColor: color
      }}></div>
    </div>
  );
}

// 버튼 내 로딩
export function ButtonSpinner() {
  return (
    <div style={styles.buttonSpinner}>
      <div style={styles.buttonSpinnerDot}></div>
      <div style={styles.buttonSpinnerDot}></div>
      <div style={styles.buttonSpinnerDot}></div>
    </div>
  );
}

const styles = {
  // 전체 화면 오버레이
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #424242',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  logoSpinner: {
    width: '80px',
    height: '80px',
    animation: 'rotate90 1.2s steps(4) infinite'
  },
  message: {
    fontSize: '16px',
    color: '#666',
    fontWeight: '500'
  },
  // 인라인 스피너
  inlineSpinner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px auto'
  },
  // 버튼 스피너
  buttonSpinner: {
    display: 'inline-flex',
    gap: '4px',
    alignItems: 'center'
  },
  buttonSpinnerDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    animation: 'pulse 1.4s ease-in-out infinite'
  }
};

// CSS 애니메이션을 App.css에 추가할 내용
export const spinnerCSS = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes rotate90 {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}

.button-spinner-dot:nth-child(1) {
  animation-delay: -0.32s;
}

.button-spinner-dot:nth-child(2) {
  animation-delay: -0.16s;
}
`;

export default LoadingSpinner;